import { render } from "./AllowList2.vue?vue&type=template&id=2d16637e"
import script from "./AllowList2.vue?vue&type=script&lang=js"
export * from "./AllowList2.vue?vue&type=script&lang=js"

import "./AllowList2.vue?vue&type=style&index=0&id=2d16637e&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__